var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(5208), __webpack_require__.e(1125), __webpack_require__.e(5899), __webpack_require__.e(2302), __webpack_require__.e(2807), __webpack_require__.e(5170), __webpack_require__.e(8877), __webpack_require__.e(5478), __webpack_require__.e(313)]).then(() => (() => ((__webpack_require__(8016)))));
	},
	"./SIVBillingAttachmentCreate": () => {
		return Promise.all([__webpack_require__.e(5208), __webpack_require__.e(1125), __webpack_require__.e(5899), __webpack_require__.e(4532), __webpack_require__.e(2302), __webpack_require__.e(2807), __webpack_require__.e(5170), __webpack_require__.e(8650), __webpack_require__.e(5478), __webpack_require__.e(5522)]).then(() => (() => ((__webpack_require__(5522)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});